import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import Swal from 'sweetalert2';
import { State, City } from "country-state-city";
import { EditLrAPI, fatchLRAPI } from '../../redux/actionCreation';
import Select from "react-select";
import Loader from '../Loader';

// const chargesConfig = [
//     { key: 'transportation', label: 'Transportation Charge' },
//     { key: 'packing', label: 'Packing Charge' },
//     { key: 'unpacking', label: 'Unpacking Charge' },
//     { key: 'loading', label: 'Loading Charge' },
//     { key: 'unloading', label: 'Unloading Charge' },
//     { key: 'insurance', label: 'Insurance Charge' },
//     { key: 'storage', label: 'Storage Charge' },
//     { key: 'service', label: 'Service Charge' },
//     { key: 'other', label: 'Other Charge' },
// ];

const LrEditPop = ({ LrId, allData }) => {
    const dispatch = useDispatch();
    const closeBtnRef = useRef(null);
    const [loading_update, setLoading_update] = useState(false);
        const errors = useSelector(
            state => state.EditLrReducers?.error?.errors
        );
    

// 1. Initial states ko khali rakhein, useEffect se bharenge
const [includeCharge, setIncludeCharge] = useState({});
const [formDatainclude, setFormDatainclude] = useState({});


  const [formData, setFormData] = useState({
        lr_date: new Date(),
        lr_number: "",
        risk_type: "AT OWNER'S RISK",
        truck_number: "",
    
        driver_name: "",
        driver_phone: "",
        driver_licence: "",
    
        consignor_name: "",
        consignor_phone: "",
        consignor_gst: "",
        consignor_state: "",
        consignor_city: "",
        consignor_add: "",
    
        consignee_name: "",
        consignee_phone: "",
        consignee_gst: "",
        consignee_state: "",
        consignee_city: "",
        consignee_add: "",
    
        no_package: "",
        ac_weight: "",
        ac_weight_type: "KG",
        char_weight: "",
        charg_weight_type: "KG",
        pack_condition: "ALL ITEMS IN GOOD CONDITION",
        pack_desc: "",
        remark: "",
    
        f_to_bill: "",
        f_paid: "",
        f_to_pay: "",
        total_basic_f: "",
    
        loading_charge: "",
        unloading_charge: "",
        st_charge: "",
        other_charge: "",
        lrcn_charge: "",
    
        gst_per: "18",
        gst_paid_by: "",
    
        material_Insu: "",
        insu_company: "",
        policy_num: "",
        insu_date: new Date(),
        insu_amount: "",
        insu_risk: "",
    
        demurrage_charge: "",
        demurrage_type: "",
        demurrage_time: "",
      });
  


  // Prefill form when LrId or allData changes
  useEffect(() => {
    if (LrId && allData && allData.length > 0) {
      const selectedLr = allData.find(lr => lr.id === LrId);
      if (selectedLr) {
        const defaultTime = new Date();
        defaultTime.setHours(0, 0, 0, 0);

        setFormData({
          lr_date: selectedLr.lr_date ? new Date(selectedLr.lr_date + "T00:00:00") : defaultTime,
          lr_number: selectedLr.lr_number || "",
          risk_type: selectedLr.risk_type || "AT OWNER'S RISK",
          truck_number: selectedLr.truck_number || "",
          driver_name: selectedLr.driver_name || "",
          driver_phone: selectedLr.driver_phone || "",
          driver_licence: selectedLr.driver_licence || "",
          consignor_name: selectedLr.consignor_name || "",
          consignor_phone: selectedLr.consignor_phone || "",
          consignor_gst: selectedLr.consignor_gst || "",
          consignor_state: selectedLr.consignor_state || "",
          consignor_city: selectedLr.consignor_city || "",
          consignor_add: selectedLr.consignor_add || "",
          consignee_name: selectedLr.consignee_name || "",
          consignee_phone: selectedLr.consignee_phone || "",
          consignee_gst: selectedLr.consignee_gst || "",
          consignee_state: selectedLr.consignee_state || "",
          consignee_city: selectedLr.consignee_city || "",
          consignee_add: selectedLr.consignee_add || "",
          no_package: selectedLr.no_package || "",
          ac_weight: selectedLr.ac_weight || "",
          ac_weight_type: selectedLr.ac_weight_type || "KG",
          char_weight: selectedLr.char_weight || "",
          charg_weight_type: selectedLr.charg_weight_type || "KG",
          pack_condition: selectedLr.pack_condition || "ALL ITEMS IN GOOD CONDITION",
          pack_desc: selectedLr.pack_desc || "",
          remark: selectedLr.remark || "",
          f_to_bill: selectedLr.f_to_bill || "",
          f_paid: selectedLr.f_paid || "",
          f_to_pay: selectedLr.f_to_pay || "",
          total_basic_f: selectedLr.total_basic_f || "",
          loading_charge: selectedLr.loading_charge || "",
          unloading_charge: selectedLr.unloading_charge || "",
          st_charge: selectedLr.st_charge || "",
          other_charge: selectedLr.other_charge || "",
          lrcn_charge: selectedLr.lrcn_charge || "",
          gst_per: selectedLr.gst_per || "",
          gst_paid_by: selectedLr.gst_paid_by || "",
          material_Insu: selectedLr.material_Insu || "",
          insu_company: selectedLr.insu_company || "",
          policy_num: selectedLr.policy_num || "",
          insu_date: selectedLr.insu_date ? new Date(selectedLr.insu_date + "T00:00:00") : defaultTime,
          insu_amount: selectedLr.insu_amount || "",
          insu_risk: selectedLr.insu_risk || "",
          demurrage_charge: selectedLr.demurrage_charge || "",
          demurrage_type: selectedLr.demurrage_type || "",
          demurrage_time: selectedLr.demurrage_time || "",
        });
      }
    }
  }, [LrId, allData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

const handleUpdate = async (e) => {
    if (e) e.preventDefault();
    setLoading_update(true);

    // 1. Helper: Date ko safely string mein badalne ke liye (Rangeerror_edit Fix)
    const formatDateForDB = (dateVal) => {
        // Agar date null, undefined, "NA" ya khali string hai
        if (!dateVal || dateVal === "NA" || dateVal === "") return "NA";
        
        const d = new Date(dateVal);
        
        // Check if Date object is valid before calling any methods
        if (isNaN(d.getTime())) return "NA";
        
        try {
            // Safe format: YYYY-MM-DD
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        } catch (err) {
            console.error_edit("Date formatting error_edit:", err);
            return "NA";
        }
    };

    // 2. Charges Logic: Checkbox ke hisaab se values set karein
    // const finalCharges = {};
    // chargesConfig.forEach(item => {
    //     const key = `${item.key}_charge`;
    //     // Agar checkbox checked hai toh "Included", varna numeric value
    //     finalCharges[key] = includeCharge[item.key] ? "Included" : (formDatainclude[key] || "0");
    // });

    // 3. Sab kuch merge karein
    const updatedData = {
        ...formData,
        
        // Teeno dates ko safely convert karein
        lr_date: formatDateForDB(formData.lr_date),
        insu_date: formatDateForDB(formData.insu_date),
        shift_end_date: formatDateForDB(formData.shift_end_date),
    };

    // 4. API Dispatch
    try {
        const res = await dispatch(EditLrAPI(updatedData, LrId));

        if (res?.type === "ADD_DATA_SUCCESS_EDIT_LR") {
            if (closeBtnRef.current) closeBtnRef.current.click();
            
            Swal.fire({ 
                icon: 'success',
                title: 'Quotation Updated Successfully!', 
                showConfirmButton: true,
                timer: 1500 
            });

            // List refresh karein
            dispatch(fatchLRAPI());
        } else {
            Swal.fire({ icon: 'error_edit', title: 'Update Failed!', text: 'Please try again.' });
        }
    } catch (error_edit) {
        console.error_edit("Update error_edit:", error_edit);
        Swal.fire({ icon: 'error_edit', title: 'error_edit', text: 'Something went wrong!' });
    } finally {
        setLoading_update(false);
    }
};

 // State for From Location

 // State for From Location
// --- 1. State Variables ---
// Consignor ke liye
const [fromCities, setFromCities] = useState([]);
const [selectedFromState, setSelectedFromState] = useState(null);
const [selectedFromCity, setSelectedFromCity] = useState(null);

// Consignee ke liye
const [toCities, setToCities] = useState([]);
const [selectedToState, setSelectedToState] = useState(null);
const [selectedToCity, setSelectedToCity] = useState(null);


// --- 2. States Array (Value = Name for DB, isoCode for filtering) ---
const states = useMemo(() => State.getStatesOfCountry("IN").map((state) => ({
    value: state.name,     // DB mein "Gujarat" jayega
    label: state.name,     // UI mein "Gujarat" dikhega
    isoCode: state.isoCode // City load karne ke liye
})), []);

// --- 3. Load Data when Editing (From Location) ---
// useEffect(() => {
//     if (formData.from_state) {
//         const stateObj = states.find(s => s.value === formData.from_state || s.isoCode === formData.from_state);
//         if (stateObj) {
//             setSelectedState(stateObj);
//             const filteredCities = City.getCitiesOfState("IN", stateObj.isoCode).map(city => ({
//                 value: city.name,
//                 label: city.name
//             }));
//             setCities(filteredCities);
//             if (formData.from_city) {
//                 const cityObj = filteredCities.find(c => c.value === formData.from_city);
//                 setSelectedCity(cityObj || { value: formData.from_city, label: formData.from_city });
//             }
//         }
//     }
// }, [formData.from_state, states]);

// --- 4. Load Data when Editing (To Location) ---
// --- CONSIGNOR (FROM) EFFECT ---


// --- CONSIGNOR (FROM) EFFECT ---
useEffect(() => {
    if (formData.consignor_state) {
        const stateObj = states.find(s => s.value === formData.consignor_state || s.isoCode === formData.consignor_state);
        if (stateObj) {
            setSelectedFromState(stateObj);
            const filteredCities = City.getCitiesOfState("IN", stateObj.isoCode).map(city => ({
                value: city.name,
                label: city.name
            }));
            setFromCities(filteredCities);
            
            if (formData.consignor_city) {
                const cityObj = filteredCities.find(c => c.value === formData.consignor_city);
                setSelectedFromCity(cityObj || { value: formData.consignor_city, label: formData.consignor_city });
            } else {
                setSelectedFromCity(null); // Agar city empty hai toh dropdown clear karein
            }
        }
    }
}, [formData.consignor_state, formData.consignor_city, states]); // Added city to dependency

// --- CONSIGNEE (TO) EFFECT ---
useEffect(() => {
    if (formData.consignee_state) {
        const stateObj = states.find(s => s.value === formData.consignee_state || s.isoCode === formData.consignee_state);
        if (stateObj) {
            setSelectedToState(stateObj);
            const filteredCities = City.getCitiesOfState("IN", stateObj.isoCode).map(city => ({
                value: city.name,
                label: city.name
            }));
            setToCities(filteredCities);
            
            if (formData.consignee_city) {
                const cityObj = filteredCities.find(c => c.value === formData.consignee_city);
                setSelectedToCity(cityObj || { value: formData.consignee_city, label: formData.consignee_city });
            } else {
                setSelectedToCity(null);
            }
        }
    }
}, [formData.consignee_state, formData.consignee_city, states]); // Added city to dependency

// --- 5. Handlers ---
// --- CONSIGNOR HANDLERS ---
// --- CONSIGNOR HANDLERS ---
const handleStateChange = (selectedOption) => {
    setSelectedFromState(selectedOption);
    setSelectedFromCity(null);
    setFormData(prev => ({ 
        ...prev, 
        consignor_state: selectedOption?.value || "", 
        consignor_city: "" 
    }));
    
    if (selectedOption) {
        // Yahan variable ka naam 'newCities' ya 'filtered' rakhein taaki confusion na ho
        const cityList = City.getCitiesOfState("IN", selectedOption.isoCode).map(c => ({ 
            value: c.name, 
            label: c.name 
        }));
        setFromCities(cityList); // 'cities' ki jagah 'fromCities' use karein
    }
};
const handleCityChange = (selectedOption) => {
    setSelectedFromCity(selectedOption);
    setFormData(prev => ({ ...prev, consignor_city: selectedOption?.value || "" }));
};

// --- CONSIGNEE HANDLERS ---
const handleToStateChange = (selectedOption) => {
    setSelectedToState(selectedOption);
    setSelectedToCity(null);
    setFormData(prev => ({ 
        ...prev, 
        consignee_state: selectedOption?.value || "", 
        consignee_city: "" 
    }));
    if (selectedOption) {
        const cities = City.getCitiesOfState("IN", selectedOption.isoCode).map(c => ({ value: c.name, label: c.name }));
        setToCities(cities);
    }
};

const handleToCityChange = (selectedOption) => {
    setSelectedToCity(selectedOption);
    setFormData(prev => ({ ...prev, consignee_city: selectedOption?.value || "" }));
};



    // Populate Data
    useEffect(() => {
        if (LrId && allData) {
            const selectedQuote = allData.find(lr => lr.id === LrId);
            if (selectedQuote) {
                setFormData({
                    ...selectedQuote,
                    lr_date: selectedQuote.lr_date ? new Date(selectedQuote.lr_date) : new Date(),
                    insu_date: selectedQuote.insu_date ? new Date(selectedQuote.insu_date) : new Date(),
                    shift_start_date: selectedQuote.shift_start_date ? new Date(selectedQuote.shift_start_date) : new Date(),
                    shift_end_date: selectedQuote.shift_end_date ? new Date(selectedQuote.shift_end_date) : new Date(),
                });
            }
        }
    }, [LrId, allData]);




  const handleLrDateChange = (date) => {
          const modifiedDate = new Date(date);
          modifiedDate.setHours(0, 0, 0, 0);
          // Format the date to "dd-mm-yyyy"
          const day = String(modifiedDate.getDate()).padStart(2, '0');
          const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
          const year = String(modifiedDate.getFullYear());
      
          const formattedDate = `${day}-${month}-${year}`;
          console.log("date", formattedDate);
          // Update the recipts_date field in formData when the DatePicker changes
          setFormData((prevState) => ({
              ...prevState,
              lr_date: modifiedDate,
          }));
          };
      
          
 const handleLRInsuDateChange = (date) => {
    const modifiedDate = new Date(date);
    modifiedDate.setHours(0, 0, 0, 0);
    // Format the date to "dd-mm-yyyy"
    const day = String(modifiedDate.getDate()).padStart(2, '0');
    const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = String(modifiedDate.getFullYear());

    const formattedDate = `${day}-${month}-${year}`;
    console.log("date", formattedDate);
    // Update the recipts_date field in formData when the DatePicker changes
    setFormData((prevState) => ({
        ...prevState,
        insu_date:modifiedDate
    }));
};


        const handleStartDateChange = (date) => {
    // 1. Agar date null ya clear ki gayi hai
    if (!date || date === "NA") {
        setFormData(prev => ({ 
            ...prev, 
            shift_start_date: "",
            // Optional: Agar start date clear ho toh end date bhi clear karni ho toh
            // shift_end_date: "" 
        }));
        return;
    }

    try {
        const modifiedDate = new Date(date);
        if (isNaN(modifiedDate.getTime())) {
            setFormData(prev => ({ ...prev, shift_start_date: "" }));
            return;
        }

        modifiedDate.setHours(0, 0, 0, 0);

        setFormData((prevState) => {
            // Check logic: Agar End Date pehle se khali hai, 
            // YA End Date aur Start Date pehle se same the (matlab user ne End date manually change nahi ki thi)
            // Tabhi hum dono ko update karenge.
            
            const shouldUpdateEndDate = !prevState.shift_end_date || 
                                       prevState.shift_end_date === "NA" || 
                                       prevState.shift_end_date === "" ||
                                       new Date(prevState.shift_end_date).getTime() === new Date(prevState.shift_start_date).getTime();

            return {
                ...prevState,
                shift_start_date: modifiedDate,
                shift_end_date: shouldUpdateEndDate ? modifiedDate : prevState.shift_end_date
            };
        });

    } catch (error_edit) {
        console.error_edit("Start Date error_edit:", error_edit);
        setFormData(prev => ({ ...prev, shift_start_date: "" }));
    }
};
            const handleEndDateChange = (date) => {
                if (!date || date === "NA") {
                    setFormData(prev => ({ ...prev, shift_end_date: "" }));
                    return;
                }

                try {
                    const modifiedDate = new Date(date);
                    if (isNaN(modifiedDate.getTime())) {
                        setFormData(prev => ({ ...prev, shift_end_date: "" }));
                        return;
                    }

                    modifiedDate.setHours(0, 0, 0, 0);
                    setFormData(prev => ({ ...prev, shift_end_date: modifiedDate }));
                } catch (error_edit) {
                    console.error_edit("End Date error_edit:", error_edit);
                    setFormData(prev => ({ ...prev, shift_end_date: "" }));
                }
            };

 const handleNumberChange = (e) => {
  const { name, value } = e.target;

  // empty allow
  if (value === '') {
    setFormData({ ...formData, [name]: '' });
    return;
  }

  // minus ya negative block
  if (Number(value) < 0) return;

  setFormData({ ...formData, [name]: value });
};

const handleLRNumberChange = (e) => {
  const { name, value } = e.target;

  // empty allow (backspace)
  if (value === '') {
    setFormData(prev => ({ ...prev, [name]: '' }));
    return;
  }

  // only numbers > 0
  const num = Number(value);

  if (!Number.isInteger(num) || num <= 0) return;

  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

const blockInvalidKeys = (e) => {
  if (e.key === '-' || e.key === 'e' || e.key === '+') {
    e.preventDefault();
  }
};


const blockInvalidLRKeys = (e) => {
  if (
    e.key === '-' ||
    e.key === '+' ||
    e.key === 'e' ||
    e.key === 'E' ||
    e.key === '.'
  ) {
    e.preventDefault();
  }
};
    return (
        <div class="offcanvas offcanvas-start" data-bs-backdrop="static" tabIndex="-1" id="staticBackdropLr" aria-labelledby="staticBackdropLabel" style={{ zIndex: 99999999999 }}>
                <div class="offcanvas-header bg-info">
                    <h5 class="offcanvas-title text-white" id="staticBackdropLabel2">Edit LR</h5>
                    <button type="button" ref={closeBtnRef} class="btn-close btn-close2" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                
                <div class="offcanvas-body">
                    <div>
                            <Form onSubmit={handleUpdate}>
                                    <Row className="mb-3">
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                        <h6 className='mb-0 bg-gray p-2'>LR-Lorry Receipt Details (बिल्टी की जानकारी)</h6>
                                            <hr className='w-10'/>
                                        </Col>

                                        <Form.Group as={Col} md="6" className='mt-3'>
                                            <Form.Label>Lr Number</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min={0}
                                                name="lr_number"
                                                value={formData.lr_number || ''}
                                                onChange={handleLRNumberChange}
                                                onKeyDown={blockInvalidLRKeys }
                                            />
                                             {errors?.lr_number && (
                                                <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                    {errors.lr_number}
                                                </span>
                                            )}
                                        </Form.Group>

                                        <Form.Group as={Col} md="6" className='mt-3'>
                                            <Form.Label>LR Date (LR की तारीख)</Form.Label>
                                            <div className="date-picker-container">
                                                <DatePicker
                                                selected={formData.lr_date}
                                                onChange={(date) => handleLrDateChange(date, 'lr_date')}
                                                dateFormat="dd-MM-yyyy"
                                                className="form-control"
                                                />
                                            </div>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Risk Type (किसका रिस्क है?)</Form.Label>
                                        <select
                                            className='form-select'
                                            name="risk_type"
                                            value={formData.risk_type}
                                            onChange={handleChange}
                                        >
                                            <option value="AT OWNER'S RISK">AT OWNER'S RISK</option>
                                            <option value="AT CARRIER'S RISK">AT CARRIER'S RISK</option>
                                        </select>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Vehicle Number (गाड़ी नंबर)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="truck_number"
                                            value={formData.truck_number || ''}
                                            onChange={handleChange}
                                        />
                                        </Form.Group>

                                        {/* ================= DRIVER ================= */}
                                        <Col xs="12">
                                        <h6 className='mb-0 bg-gray p-2 mt-3'>Driver Information (ड्राइवर की जानकारी)</h6>
                                            <hr className='w-10'/>
                                        </Col>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Driver Name</Form.Label>
                                        <Form.Control
                                            name="driver_name"
                                            value={formData.driver_name}
                                            onChange={handleChange}
                                            placeholder="Driver Name"
                                        />
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Driver Number</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="driver_phone"
                                            value={formData.driver_phone}
                                            onChange={handleNumberChange} onKeyDown={blockInvalidKeys}
                                            placeholder="Driver Mobile"
                                             onInput={(e) => {
                                                if (e.target.value.length > 10) {
                                                    e.target.value = e.target.value.slice(0, 10);
                                                }
                                            }}/>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Driver Licence</Form.Label>
                                        <Form.Control
                                            name="driver_licence"
                                            value={formData.driver_licence}
                                            onChange={handleChange}
                                            placeholder="Licence No"
                                        />
                                        </Form.Group>

                                        {/* ================= CONSIGNOR ================= */}
                                        <Col xs="12">
                                        <h6 className='mb-0 bg-gray p-2 mt-3'>Consignor / Move From</h6>
                                        <hr className='w-10'/>
                                        </Col>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Consignor Name (भेजने वाले का नाम)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="consignor_name"
                                            value={formData.consignor_name || ''}
                                            onChange={handleChange}
                                            placeholder="Consignor Name"
                                            required
                                        />
                                        {errors?.consignor_name && (
                                                <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                    {errors.consignor_name}
                                                </span>
                                            )}
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Consignor Number (भेजने वाले का फोन)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="consignor_phone"
                                            value={formData.consignor_phone || ''}
                                           onChange={handleNumberChange} onKeyDown={blockInvalidKeys}
                                            placeholder="Consignor Phone" onInput={(e) => {
                                                if (e.target.value.length > 10) {
                                                    e.target.value = e.target.value.slice(0, 10);
                                                }
                                            }}/>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Consignor GST (भेजने वाले का जीएसटी नंबर)</Form.Label>
                                        <Form.Control
                                            name="consignor_gst"
                                            value={formData.consignor_gst || ''}
                                            onChange={handleChange}
                                            placeholder="GSTIN"
                                        />
                                        </Form.Group>

                                        <Form.Group as={Col} md="6" className="mt-3">
                                        <Form.Label>Consignor State (भेजने वाले का राज्य)</Form.Label>
                                        <Select
                                            options={states}
                                            value={states.find(s => s.value === formData.consignor_state)}
                                            onChange={handleStateChange}
                                            placeholder="From State"
                                        />
                                        </Form.Group>

                                       <Form.Group as={Col} md="6" className="mt-3">
                                       <Form.Label>Consignor City (भेजने वाले का शहर)</Form.Label>
                                        <Select
                                            // 'cities' ko badal kar 'fromCities' kiya
                                            options={fromCities} 
                                            
                                            // value mein bhi 'fromCities' check karega
                                            value={fromCities?.find(c => c.value === formData.consignor_city) || null} 
                                            
                                            onChange={handleCityChange}
                                            placeholder="From City"
                                            isClearable // Optional: Taaki user select ki hui city hata sake
                                        />
                                    </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Consignor Address (भेजने वाले का पता)</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="consignor_add"
                                            value={formData.consignor_add || ''}
                                            onChange={handleChange}
                                        />
                                        </Form.Group>

                                        {/* ================= CONSIGNEE ================= */}
                                        <Col xs="12">
                                        <h6 className='mb-0 bg-gray p-2 mt-3'>Consignee / Move To</h6>
                                        <hr className='w-10'/>
                                        </Col>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Consignee Name (पाने वाले का नाम)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="consignee_name"
                                            value={formData.consignee_name || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                          {errors?.consignee_name && (
                                                <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                    {errors.consignee_name}
                                                </span>
                                            )}
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Consignee Number (पाने वाले का फोन)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="consignee_phone"
                                            value={formData.consignee_phone || ''}
                                            onChange={handleNumberChange} onKeyDown={blockInvalidKeys}
                                             onInput={(e) => {
                                                if (e.target.value.length > 10) {
                                                    e.target.value = e.target.value.slice(0, 10);
                                                }
                                            }}/>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Consignee GST (पाने वाले का जीएसटी नंबर)</Form.Label>
                                        <Form.Control
                                            name="consignee_gst"
                                            value={formData.consignee_gst || ''}
                                            onChange={handleChange}
                                            placeholder="GSTIN"
                                        />
                                        </Form.Group>

                                        <Form.Group as={Col} md="6" className="mt-3">
                                        <Form.Label>Consignee State (पाने वाले का राज्य)</Form.Label>
                                        <Select
                                            options={states}
                                            value={states.find(s => s.value === formData.consignee_state)}
                                            onChange={handleToStateChange}
                                            placeholder="To State"
                                        />
                                        </Form.Group>

                                        <Form.Group as={Col} md="6" className="mt-3">
                                        <Form.Label>Consignee City (पाने वाले का शहर)</Form.Label>
                                        <Select
                                            options={toCities}
                                            value={toCities.find(c => c.value === formData.consignee_city)}
                                            onChange={handleToCityChange}
                                            placeholder="To City"
                                        />
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" className='mt-3'>
                                        <Form.Label>Consignee Address (पाने वाले का पता)</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="consignee_add"
                                            value={formData.consignee_add || ''}
                                            onChange={handleChange}
                                        />
                                        </Form.Group>   
                                        
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <h6 className='mb-0 mt-3 bg-gray p-2'>Package Details (पैकेज का विवरण):</h6>
                                            <hr className='w-10'/>
                                                <Form.Label className='mt-3'>No. Of Package (पैकेज की संख्या) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="No. Of Package.." name="no_package" value={formData.no_package}/>

                                                <fieldset className='mt-3'>
                                                    <label for="total_weight">Actual Weight (वास्तविक वजन)</label>
                                                        <div class="input-group mt-2">
                                                            <Form.Control type="number" class="form-control" placeholder="" aria-label="Charged Weight" name="ac_weight" id="actual_weight" value={formData.ac_weight} onChange={handleNumberChange} onKeyDown={blockInvalidKeys}/>
                                                                    <div class="input-group-append">
                                                                       <select name="ac_weight_type" class="form-main form-select" id="ac_weight_type" value={formData.ac_weight_type} onChange={handleChange}>
                                                                           <option value="KG">KG</option>
                                                                           <option value="MT">MT</option>
                                                                           <option value="LTR">LTR</option>
                                                                           <option value="CBM">CBM</option>
                                                                           <option value="CFT">CFT</option>
                                                                           <option value="FTL">CFT</option>
                                                                           <option value="">None</option>
                                                                       </select>
                                                                </div>
                                                            </div>
                                                </fieldset>

                                                <fieldset className='mt-3'>
                                                    <label for="total_weight">Charged Weight (चार्ज किया गया वजन)</label>
                                                        <div class="input-group mt-2">
                                                            <Form.Control type="number" class="form-control" placeholder="" aria-label="Charged Weight" name="char_weight" id="char_weight" value={formData.char_weight} onChange={handleNumberChange} onKeyDown={blockInvalidKeys}/>
                                                                    <div class="input-group-append">
                                                                       <select name="charg_weight_type" class="form-main form-select" id="charg_weight_type" value={formData.charg_weight_type} onChange={handleChange}>
                                                                           <option value="KG">KG</option>
                                                                           <option value="MT">MT</option>
                                                                           <option value="LTR">LTR</option>
                                                                           <option value="CBM">CBM</option>
                                                                           <option value="CFT">CFT</option>
                                                                           <option value="FTL">CFT</option>
                                                                           <option value="">None</option>
                                                                       </select>
                                                                </div>
                                                            </div>
                                                </fieldset>

                                                <Form.Label className='mt-3'>Receive Package Condition (प्रपात माल की स्थिति) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="text" onChange={handleChange} placeholder="Receive Package Condition.." name="pack_condition" value={formData.pack_condition}/>

                                                <Form.Label className='mt-3'>Package Description (पैकेज का विवरण)</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder="Package Description.." onChange={handleChange} name="pack_desc" value={formData.pack_desc}/>

                                                <Form.Label className='mt-3'>Remark (अन्य विवरण)</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder="Remark.." onChange={handleChange} name="remark" value={formData.remark}/>
                                        </Col>

                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <h6 className='mb-0 mt-3 bg-gray p-2'>Package Details (पैकेज का विवरण):</h6>
                                            <hr className='w-10'/>

                                                <Form.Label className='mt-3'>Freight To Be Billed (कुल भाड़ा) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Freight To Be Billed.." name="f_to_bill" value={formData.f_to_bill}/>

                                                 <Row>
                                                    <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                    <Form.Label>Freight Paid (प्राप्त भाड़ा)<span className="text-danger"></span></Form.Label>
                                                    <Form.Control 
                                                        type="number" 
                                                        min={0} 
                                                        placeholder="Freight Paid.." 
                                                        name="f_paid" 
                                                        value={formData.f_paid || ''} // State se value connect karein
                                                        onChange={handleNumberChange} onKeyDown={blockInvalidKeys}             // onChange handler lagayein
                                                        required 
                                                    />
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Freight To Pay (बकाया भाड़)<span className="text-danger"></span></Form.Label>
                                                        <Form.Control 
                                                            type="number" 
                                                            min={0} 
                                                            placeholder="Freight To Pay.." 
                                                            name="f_to_pay" 
                                                            value={formData.f_to_pay || ''} // State se value connect karein
                                                            onChange={handleNumberChange} onKeyDown={blockInvalidKeys}               // onChange handler lagayein
                                                            required 
                                                        />
                                                     </Form.Group>
                                                    
                                                     <Form.Group>
                                                        <hr class="w-100 mb-0"></hr>
                                                     </Form.Group>
                                                        
                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Total Basic Freight <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Total Basic Freight.." name="total_basic_f" value={formData.total_basic_f}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Loading Charge <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Loading Charge.." name="loading_charge" value={formData.loading_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Unloading Charge <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Unloading Charge.." name="unloading_charge" value={formData.unloading_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>S.T Charge <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="S.T Charge.." name="st_charge" value={formData.st_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Other Charges <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Other Charges.." name="other_charge" value={formData.other_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>LR/CN Charges <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="LR/CN Charges.." name="lrcn_charge" value={formData.lrcn_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>GST % <span class="text-danger"></span></Form.Label>
                                                        <select name="gst_per" class="form-main form-select" value={formData.gst_per}  onChange={handleChange}>
                                                            <option value="0">0</option>
                                                            <option value="5">5</option>
                                                            <option value="12">12</option>
                                                            <option value="18" selected>18</option>
                                                            <option value="28">28</option>
                                                        </select>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>GST Paid By<span class="text-danger"></span></Form.Label>
                                                        <select name="gst_paid_by" class="form-main form-select" value={formData.gst_paid_by}  onChange={handleChange}>
                                                            <option value="Consignee">Consignee</option>
                                                            <option value="Consignor">Consignor</option>
                                                            <option value="Transporter">Transporter</option>
                                                            <option value="Exempted">Exempted</option>
                                                        </select>
                                                     </Form.Group>
                                                 </Row>
                                        </Col>
                                        
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <h6 className='mb-0 mt-3 bg-gray p-2'>Insurance (सामान का बीमा):</h6>
                                            <hr className='w-10'/>
                                                <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className=''>
                                                        <Form.Label className='mt-3'>Material Insurance (क्या सामान का बीमा है?)<span class="text-danger"></span></Form.Label>
                                                        <select name="material_Insu" class="form-main form-select" value={formData.material_Insu}  onChange={handleChange}>
                                                            <option value="Insured">Insured</option>
                                                            <option value="Not Insured">Not Insured</option>
                                                        </select>
                                                </Form.Group>

                                                <Form.Label className='mt-3'>Insurance Company (बीमा कंपनी) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="text" onChange={handleChange} placeholder="Insurance Company.." name="insu_company" value={formData.insu_company}/>

                                                <Form.Label className='mt-3'>Policy Number (बीमा पॉलिसी नंबर) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="text" onChange={handleChange} placeholder="Policy Number.." name="policy_num" value={formData.policy_num}/>

                                                {/* <Form.Label className='mt-3'>Insurance Date (बीमा तारीख) <span class="text-danger"></span></Form.Label>
                                                    <div className="date-picker-container">
                                                            <i className='calendar-icon fa fa-calendar'></i>
                                                            <DatePicker
                                                                selected={formData.insu_date}
                                                                onChange={handleLRInsuDateChange}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Insurance Date"
                                                                className='form-control'
                                                                required
                                                            />
                                                    </div> */}

                                                     <Form.Group as={Col} md="12" className='mt-3'>
                                                       <Form.Label className='mt-3'>Insurance Date (बीमा तारीख) <span class="text-danger"></span></Form.Label>
                                                        <div className="date-picker-container">
                                                            <DatePicker
                                                            selected={formData.insu_date}
                                                            onChange={(date) => handleLRInsuDateChange(date, 'insu_date')}
                                                            dateFormat="dd-MM-yyyy"
                                                            className="form-control"
                                                            />
                                                        </div>
                                                    </Form.Group>

                                                <Form.Label className='mt-3'>Insured Amount (बीमा राशि) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Insured Amount.." name="insu_amount" value={formData.insu_amount}/>

                                                <Form.Label className='mt-3'>Insurance Risk (बीमा जोखिम) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="text" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Insurance Risk.." name="insu_risk" value={formData.insu_risk}/>
                                        </Col>
                                       
                                       
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                         <h6 className='mb-0 mt-3 bg-gray p-2'>Demurrage Charge (विलंब शुल्क):</h6>
                                            <hr className='w-10'/>
                                        </Col>

                                        <div className='form-group col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                                            <fieldset className='mt-3'>
                                                    <label for="total_weight" className='mb-2'>Demurrage Charge (विलंब शुल्क)</label>
                                                        <div class="input-group">
                                                            <Form.Control type="number" class="form-control" placeholder="Demurrage Charge" name="demurrage_charge" value={formData.demurrage_charge} onChange={handleNumberChange} onKeyDown={blockInvalidKeys}/>
                                                                    <div class="input-group-append">
                                                                       <select name="demurrage_type" class="form-main form-select" width="100px" value={formData.demurrage_type} onChange={handleChange}>
                                                                          <option value="Per Day">Per Day</option>
                                                                          <option value="Per Hour">Per Hour</option>
                                                                       </select>
                                                                </div>
                                                            </div>
                                                </fieldset>
                                        </div>
                                        
                                        <div className='form-group mt-3 col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                                            <label for="total_weight">Demurrage charge applicable after (कितने समय बाद शुरू)</label>
                                            <select name="demurrage_time" class="form-main form-select mt-2" value={formData.demurrage_time}  onChange={handleChange}>
                                                <option value="1 Hour">1 Hour</option>
                                                <option value="2 Hour">2 Hour</option>
                                                <option value="4 Hour">4 Hour</option>
                                                <option value="8 Hour">8 Hour</option>
                                                <option value="12 Hour">12 Hour</option>
                                                <option value="1 Day">1 Day</option>
                                                <option value="2 Day">2 Day</option>
                                                <option value="3 Day">3 Day</option>
                                                <option value="4 Day">4 Day</option>
                                                <option value="More Than 5 Day">More Than 5 Day</option>
                                            </select>
                                        </div>

                                        
                                    </Row>
                                    <Button variant="primary" type="submit" className='d-flex align-items-center justify-content-center'>
                                            <span className='mx-2'>Update</span>
                                                {loading_update && <span className='spin-sm'><Loader /></span>}
                                        </Button>
                                </Form>
                    </div>
                </div>
        </div>
    );
}

export default LrEditPop;